module.exports = __webpack_public_path__ + "media/images/kds/KDS-2-4debced0c9a417eafad74d69f1b29922.svg";